<template>
  <b-modal
    id="addexempt"
    size="sm"
    title="Add Exempt reason"
    :ref="'addexempt'"
    body-class="bg-white"
    @hidden="$emit('setMultipleAddedRefExempt', {
        close : true
      })"
    cancel-title="Close"
    :ok-title-html="field.value != ''? submitted==true?loaderIcon+'Update' :'Update': submitted==true?loaderIcon+'Save':'Save'"
    :no-close-on-backdrop="true"
    cancel-variant="light"
    :ok-disabled="submitted"
    @ok.prevent="handledetail"
    @shown="field.label=exempt_reason.label,field.value = exempt_reason.value"
  >
    <b-form-group>
      <b-row>
        <b-col lg="12">
          <label for="label" class="required">Exempt</label>
          <b-form-input
            v-validate="'required|max:50'"
            id="label"
            type="text"
            name="label"
            data-vv-name="Exempt reason"
            v-model.trim="field.label"
            placeholder
          />

          <span
            class="text-danger"
            v-if="errors.has('Exempt reason')"
          >{{ errors.first('Exempt reason')}}</span>
        </b-col>
      </b-row>
    </b-form-group>
  </b-modal>
</template>
<script>
import { notificationMixin } from "@/mixins/notification";
import { mapState } from "vuex";
import vSelect from "vue-select"; // vue seatch select component
import VeeValidate from "vee-validate"; // validation vee
export default {
  mixins: [notificationMixin],
  props: ["module", "exempt_reason"],
  components: {
    vSelect,
    VeeValidate,
  },
  data() {
    return {
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      locationClasses: "messenger-fixed messenger-on-top messenger-on-center",
      submitted: false,
      field: {
        label: "",
        value: "",
      },
    };
  },
  methods: {
    handledetail() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submitted = true;
          var data = JSON.stringify({
            exempt_reason_name: this.field.label,
            exempt_reason_id: this.field.value,
          });

          this.$store
            .dispatch(this.module + "/addexempt", data)
            .then(() => {
              //For message
              var message;
              var type;

              if (this.code == 200 && this.field.value == "") {
                // if success show the success notification
                message = "Exempt reason has been created successfully";
                type = "success";
                // redirect to index page after submission
                this.$emit("setMultipleAddedRefExempt", this.field);
                this.$refs.addexempt.hide();
                this.submitted = false;
              } else if (this.code == 200 && this.field.value != "") {
                // if success show the success notification
                message = "Exempt reason has been updated successfully";
                type = "success";
                // redirect to index page after submission
                this.$emit("setMultipleAddedRefExempt", this.field);
                this.$refs.addexempt.hide();
                this.submitted = false;
              } else {
                if (this.code || this.exemptcode == 201) this.submitted = false; // enabel the disable button after submission
                // list the message from api
                message = "Exempt reason already exists";
                type = "danger";
              }
              window.Messenger().post({
                extraClasses:
                  "messenger-fixed messenger-on-top messenger-on-center",
                message: message,
                type: type,
                showCloseButton: true,
              });
            })
            .catch(() => {});
        } else {
          this.submitted = false;
          this.error_show = true;
        }
      });
    },
  },
  created() {
    window.Messenger.options = {
      extraClasses: this.locationClasses,
      theme: "air",
    };
  },
  computed: {
    message: {
      get() {
        return this.$store.state[this.module].message;
      },
      set(val) {
        this.$store.state[this.module].message = val;
      },
    },
    code: {
      get() {
        return this.$store.state[this.module].code;
      },
      set(val) {
        this.$store.state[this.module].code = val;
      },
    },
  },
};
</script>